import clsx from "clsx";

export function Table({ children }: { children: React.ReactNode }) {
  // Table is desktop-only — each page pairs it with a mobile card layout.
  // We hide the whole wrapper below md: so it never appears on phones and
  // the page doesn't need horizontal scroll.
  return (
    <div className="hidden md:block relative rounded-md border border-border bg-panel/80 backdrop-blur-sm brackets animate-fadeIn">
      <table className="w-full text-sm font-mono">{children}</table>
    </div>
  );
}

export function Th({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <th
      className={clsx(
        "sticky top-0 z-10 bg-panel2/90 backdrop-blur-sm px-2 md:px-3 py-2 text-left text-[10px] font-bold uppercase tracking-[0.15em] text-accent2 border-b border-border whitespace-nowrap",
        className
      )}
    >
      {children}
    </th>
  );
}

export function Td({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <td
      className={clsx(
        "px-2 md:px-3 py-2 border-b border-border/50 tabular-nums text-text/90",
        className
      )}
    >
      {children}
    </td>
  );
}

export function fmtUsd(n: number | undefined, opts: { sign?: boolean } = {}): string {
  if (n === undefined || !isFinite(n)) return "—";
  const sign = opts.sign && n > 0 ? "+" : "";
  return sign + n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 });
}

export function fmtPct(n: number | undefined, opts: { sign?: boolean } = {}): string {
  if (n === undefined || !isFinite(n)) return "—";
  const sign = opts.sign && n > 0 ? "+" : "";
  return sign + n.toFixed(2) + "%";
}
